/* global global */

// Third-party imports
import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui';
import $ from 'jquery';

// Local imports
// polyfills must be applied before everything else
import '../../polyfill/index.js';

import * as donation_mod from '../../donation/init.js';
import * as global_mod from '../../global/index.js';
import { PAGE_VARS, PageKind } from '../vars.js';
import * as sgproduct_datalayer from './datalayer.js';
import * as gtm_vars from '../../datalayer/gtm/gtm_vars.js';
import * as gtm_push from '../../datalayer/gtm/gtm_push.js';
import * as tealium from '../../datalayer/tealium.js';
import { postProductToCart } from '../../util/postDonationProduct.js';
import { get_product_site_schema } from '../../site_schema/site_schema.js';
import * as event from '../../datalayer/event.js';
import { push_data_object } from '../../datalayer/gtm/gtm_push.js';
import * as shopify_data from './shopify_data.js';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'sgproduct';
export let global_vars = {};
// export const ModalEventKind = {
//     CARD_PREVIEW_MODAL_CLOSED: Symbol('checkout_card.modal.close'),
// };
// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------

function get_shopify_data(global) {
    let doc = global.document;
    let data_el = doc.getElementById('product-data');
    let data = data_el.dataset;
    let product_data = data_el.querySelector('.product').dataset;

    shopify_data.save_sgproduct_datalayer(
        // Product
        {
            id: product_data.id,
            name: product_data.name,
            category_name: product_data.category_name,
            sku: product_data.sku,
            variants: JSON.parse(product_data.variants),
            quantity: product_data.quantity,
            vendor: product_data.vendor,
            global_category: `${product_data.global_category}/ / `,
        },

        // position
        data.position,

        // listname
        data.listname
    );

    shopify_data.save_sgproduct_id(data.variant_firstid);
}

function process_shopify_data(global) {
    // Product
    for (let d of shopify_data.SHOPIFY_DATA.product) {
        sgproduct_datalayer.update_sgproduct_datalayer(
            d.product,
            d.position,
            d.listname
        );

        sgproduct_datalayer.update_sgproduct_validate_datalayer(
            global,
            d.product,
            shopify_data.SHOPIFY_DATA.first_productid
        );
    }
}

function init_pagevars() {
    PAGE_VARS.kind = PageKind.Product;
}

// global is the window object when run in browser context
function set_handlers(global) {
    // pageshow handler
    global.addEventListener('pageshow', event => {
        if (event.persisted) {
            global.location.reload();
        }
    });

    // Add submit listener for custom amount submission
    init_custom_amount_form_submit(global);

    // Add click listener to donate button
    init_donate_button_click(global);

    // Add keydown events for input fields in the donate in memory form
    init_donate_in_memory_fields(global);

    //Remove Required Fields in the Donation Form
    init_donate_in_memory_remove_required_fields(global);

    // Add a toggle event for the send letter checkbox
    init_donate_in_memory_letter_toggle(global);

    //Add a change event to the Type of Email field
    // init_donate_in_memory_type_of_mail_toggle(global);


}

function init_custom_amount_form_submit(global) {
    let form = global.document.getElementById('donateForm');
    form.addEventListener('submit', event => {
        event.preventDefault();
        //onSubmitForm(global);
    });
}

function init_donate_button_click(global) {
    let donate_button = global.document.getElementById('add');
    donate_button.addEventListener('click', () => {
        onSubmitForm(global);
    });
}

// We add keydown events on all input fields if there are more
// than one. This is because the submit event is not fired
// when enter is pressed in an input field, if there are multiple
// input fields in a form that does not have an input field set
// to submit type. Which is how our form is currently set up
function init_donate_in_memory_fields(global) {
    let form = global.document.getElementById('donateForm');

    if (form.dataset.isInMemory === 'true') {
        let inputFields = form.querySelectorAll('input[type=text]');

        for (let field of inputFields) {
            field.addEventListener('keyup', event => {
                if (event.key === 'Enter') {
                    onSubmitForm(global);
                }
            });
        }
    }
}

// Adds a listener to the send letter checkbox if the product is
// Donate In Memory. This is used to clear the extra input
// fields when the checkbox is unchecked
function init_donate_in_memory_letter_toggle(global) {
    let form = global.document.getElementById('donateForm');
    if (form.dataset.isInMemory === 'true') {
        let letterCheckbox = global.document.getElementById('sympathy');

        letterCheckbox.addEventListener('change', () => {
            if (!letterCheckbox.checked) {
                clearDonateInMemoryExtraFields(global);
                init_donate_in_memory_remove_required_fields(global);
            } else {
                init_donate_in_memory_type_of_mail_toggle(global);
            }
        });
    }
}

// Clears the fields in the extra form part of the Donate In Memory page
function clearDonateInMemoryExtraFields(global) {
    let doc = global.document;
    // Type of Mail Field
    doc.getElementById('type_of_mail').selectedIndex = 1;
    const e = new Event("change");
    const element = doc.getElementById('type_of_mail')
    element.dispatchEvent(e);
    // Title Select Field
    doc.getElementById('title').selectedIndex = 0;
    // First Name Input Field
    doc.getElementById('firstName').value = '';
    // Last Name Input Field
    doc.getElementById('lastName').value = '';
    // Address Input Field
    doc.getElementById('address').value = '';
    // City Input Field
    doc.getElementById('city').value = '';
    // Province Select
    doc.getElementById('province').selectedIndex = 0;
    // Postal Code Input Field
    doc.getElementById('postal').value = '';
    // Donor's Message to the Family of Deceased Field
    doc.getElementById('donor_message').value = '';
    // Email Address of Family of Deceased Field
    doc.getElementById('email_address').value = '';
    //Sender First Name Input Field
    doc.getElementById('sender_first_name').value = '';
    //Sender Last Name Input Field
    doc.getElementById('sender_last_name').value = '';
}

function init_donate_in_memory_remove_required_fields(global) {
    let form = global.document.getElementById('donateForm');

    global.document.getElementById('title').selectedIndex = 0;
    global.document.getElementById('type_of_mail').selectedIndex = 0;

    var req_fields = form.querySelectorAll('.em-required, .pm-required, .js-required');

    // Loop through each of the selected elements and remove the 'required' attribute
    req_fields.forEach(function (element) {
        element.removeAttribute('required');
    });

}

// Adds a listener to the Type of Mail if the product is
// Donate In Memory. This is used to hide the Email Field
// when the user choose Print Mail
function init_donate_in_memory_type_of_mail_toggle(global) {
    let form = global.document.getElementById('donateForm');
    var inputField = document.getElementById('customAmount');
    // Remove the placeholder attribute
    inputField.removeAttribute('placeholder');
    // Set a new placeholder text
    inputField.setAttribute('placeholder', 'Min. $10');

    if (form.dataset.isInMemory === 'true') {
        global.document.getElementById('title').selectedIndex = 1;
        global.document.getElementById('type_of_mail').selectedIndex = 1;

        let type_of_mail = global.document.getElementById('type_of_mail');

        var em_req_fields = form.querySelectorAll('.em-required');
        for (let em of em_req_fields) {
            em.required = true;
        }

        type_of_mail.addEventListener('change', () => {
            let type_of_mail_div = document.getElementById('type_of_mail_div');

            let display_print = "none";
            let pm_required = false;

            let display_email = "none";
            let em_required = false;

            if (type_of_mail.value == "Print") {
                type_of_mail_div.classList.remove('grid-1of2');
                type_of_mail_div.classList.add('grid-1of1');
                //If the mail type is PRINT, display the address information fields.
                display_print = "inline-block";
                pm_required = true;

                display_email = "none";
                em_required = false;

            } else {
                type_of_mail_div.classList.remove('grid-1of1');
                type_of_mail_div.classList.add('grid-1of2');
                display_print = "none";
                pm_required = false;

                display_email = "inline-block";
                em_required = true;
            }

            let print_fields = form.querySelectorAll('.mail-print');
            for (let pf of print_fields) {
                pf.style.display = display_print;
            }

            //If the mail type is EMAIL, make the address information required.
            var pm_req_fields = form.querySelectorAll('.pm-required');
            for (let pm of pm_req_fields) {
                pm.required = pm_required;
            }

            //If the mail type is EMAIL, display the required fields for sending email.
            let email_fields = form.querySelectorAll('.mail-email');
            for (let ef of email_fields) {
                ef.style.display = display_email;
            }

            for (let em of em_req_fields) {
                em.required = em_required;
            }
        });
    }
}

// Called when either the donate button is clicked,
// or enter is pressed in the custom amount
function onSubmitForm(global) {
    // NOTE: We cannot use event.target to get the button,
    // cause the click event can be triggered by the button's
    // children element
    let donate_button = global.document.getElementById('add');
    let spinner = donate_button.querySelector('#addButtonSpinner');

    if (!spinner.classList.contains('u-hide')) {
        return;
    }

    if (!formValidates(global)) {
        return;
    }

    // Deselect the custom amount field
    let custom_amount = global.document.getElementById('customAmount');
    custom_amount.blur();

    // Send Datalayer
    sendDatalayer(global);

    let selectedType = global.document.getElementById('typeInput').value;
    let selectedAmount = global.document.querySelector('.donationAmount').value;
    let form = global.document.getElementById('donateForm');
    postProductToCart(global, selectedType, selectedAmount, form);
}

function sendDatalayer(global) {
    let amount = global.document
        .querySelector('.donationAmount')
        .getAttribute('value');
    let product_price = amount ? amount : 0;
    let product = shopify_data.SHOPIFY_DATA.product[0].product;
    //== gtm-push: ODN product added to cart ==//
    let data_object = {
        event: 'add_to_cart',
        ecommerce: {
            items: [
                {
                    item_name: product.name,
                    item_id: product.id,
                    price: product_price,
                    item_brand: sgproduct_datalayer.get_product_brand(global),
                    item_category: product.category,
                    item_variant: product.variant,
                    item_list_name: 'Donations',
                    quantity: '1',
                },
            ],
        },
    };
    push_data_object(data_object);

    event.dispatch(global, event.EventKind.AddToCart);
}

function formValidates(global) {
    let form = global.document.getElementById('donateForm');
    let validate_success = $(form)
        .parsley()
        .validate();
    return validate_success;
}

function store_gtm_product_view(global) {
    let data_element = global.document.getElementById('product-data');
    let product_data_element = data_element.querySelector('.product');
    let dataset = product_data_element.dataset;

    global.productViews.push({
        item_name: dataset.name,
        item_id: dataset.id,
        price: dataset.product_price,
        item_category: dataset.category_name,
        item_variant: dataset.variants,
        item_list_name: 'Donations',
    });

    global.uaProductViews.push({
        name: dataset.name,
        id: dataset.id,
        price: dataset.product_price,
        category: dataset.category_name,
        variant: dataset.variants,
    });
}

function initialize(global) {
    // Get shopify data
    get_shopify_data(global);

    store_gtm_product_view(global);

    set_handlers(global);

    // Setup datalayer
    process_shopify_data(global);
    get_product_site_schema(global, 'odn');
}

export function main() {
    // Initialize all page vars
    init_pagevars();

    // Create object to pass to global initialization
    let all_modules = [];
    all_modules.push.apply(all_modules, global_mod.__all__);

    let sgproduct_mod = {
        MODULE_NAME,
        global_vars,
        initialize,
    };

    all_modules.push(gtm_vars, donation_mod, sgproduct_mod, gtm_push);

    // Insert datalayer setup module and tealium module at the beginning and end
    // of the modules array respectively
    all_modules = tealium.wrap_module_array(all_modules);

    // Initialize globals
    // The ``global`` global variable will be ``window`` when run in a browser
    // context.
    global_mod.initialize(global, all_modules);
}
